import { z } from 'zod';

export const searchSchema = z.object({
  q: z.string().trim().min(2, 'Escribe al menos 2 caracteres').max(100),
  companyId: z.string().uuid().optional(),
  limit: z.coerce.number().int().min(1).max(25).default(10),
});

export interface SearchHit {
  contactId: string;
  companyId: string;
  companyName: string;
  name: string;
  phone: string | null;
  email: string | null;
  documentNumber: string | null;
  /** Coincidencia principal: por qué apareció. */
  matchedOn: 'NOMBRE' | 'TELEFONO' | 'CORREO' | 'DOCUMENTO';
  leads: Array<{
    id: string;
    projectName: string;
    status: string;
    pipelineStage: string;
    followupState: string;
    advisorName: string | null;
    capturedAt: string;
  }>;
}
